export default "__VITE_ASSET__C3V4cq21__"